import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Using custom CSS instead of index.css with Tailwind directives
import './custom_optimized.css'
import App from './App.jsx'
import { ThemeProvider } from './theme/ThemeContext'
import { TranslationProvider } from './i18n/TranslationContext'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <TranslationProvider>
        <App />
      </TranslationProvider>
    </ThemeProvider>
  </StrictMode>,
)
